import { render, staticRenderFns } from "./PresetsManage.vue?vue&type=template&id=19936709&"
import script from "./PresetsManage.vue?vue&type=script&lang=js&"
export * from "./PresetsManage.vue?vue&type=script&lang=js&"
import style0 from "./PresetsManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports